import styles from "../../main/Filters/Filters.module.scss";
import ExportImportFilters from "./ExportImportFilters/ExportImportFilters";
import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import FilterTypes from "./FilterTypes/FilterTypes";
import AreaFilter from "./AreaFilter/AreaFilter";
import OtherFilters from "./OtherFilters/OtherFilters";
import DatasetsDropdown from "../../_mapFilterComponents/DatasetsDropdown/DatasetsDropdown";
import RegionDropdown from "../../main/RegionDropdown/RegionDropdown";
import SavedFiltersButton from "../../../templates/SavedFilters/SavedFiltersButton/SavedFiltersButton";
import MobileClearAllButton from "../../../../share/filters/MobileClearAllButton";
import ClearAllFiltersDesktopButton from "../../../../share/filters/ClearAllFiltersDesktopButton";
import AddMoreFiltersButton from "../../../templates/AddSavedFilters/AddMoreFiltersButton";
import { FilterGroup } from "../../../../share/filters";
import SearchFilter from "../../../SearchFilter/SearchFilter";
import {
  ListViewActions,
  ListViewContainer,
  ListViewFilterGroup,
  ListViewSearchRow,
  ListViewSearchSection,
  ListViewSearchWrapper,
  ListViewTopContainer,
  MapToggleButton,
} from "../../shared/ListViewLayout";
import { breakpoints, icons } from "../../../../constants";
import { UserProfileListControls } from "../../../UserProfileBar/UserProfileBar";
import useMobileScreen from "../../../../hooks/useMobileScreen";

interface FiltersProps {
  isListView?: boolean;
}

const Filters = ({ isListView = false }: FiltersProps) => {
  const {
    setCleanAllSikaDesignerFilters,
    getDefaultSikaDesignerResult,
    setIsIncomeBigger,
    setIs21Plus,
    setOffset,
    setPage,
    setIsListViewActive,
  } = useActions();
  const { is21plus, isIncomeBigger } = useTypedSelector(
    (state) => state.sikaDesignerFilters
  );
  const handleClick = () => {
    setOffset(0);
    setPage(1);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handle21PlusChange = () => {
    setIs21Plus(!is21plus);
    handleClick();
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleIncomeBiggerChange = () => {
    setIsIncomeBigger(!isIncomeBigger);
    handleClick();
  };
  const handleClean = () => {
    setCleanAllSikaDesignerFilters();
    getDefaultSikaDesignerResult();
  };

  const isBelowMedium = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListView && !isBelowMedium;

  const handleShowMap = () => {
    setIsListViewActive(false);
  };

  if (shouldRenderListView) {
    return (
      <ListViewContainer>
        <ListViewTopContainer>
          <div className={styles.regionsDatasetsWrapper}>
            <RegionDropdown />
            <DatasetsDropdown />
          </div>
          <ListViewActions>
            <SavedFiltersButton />
            <AddMoreFiltersButton />
            <UserProfileListControls />
          </ListViewActions>
        </ListViewTopContainer>
        <ListViewSearchSection>
          <ListViewSearchRow>
            <MapToggleButton
              type="button"
              onClick={handleShowMap}
              aria-label="Show map view"
            >
              <img src={icons.NavMapIcon} alt="Show map view" />
            </MapToggleButton>
            <ListViewSearchWrapper>
              <SearchFilter />
            </ListViewSearchWrapper>
            <ListViewFilterGroup onClick={(event) => event.stopPropagation()}>
              <FilterTypes />
              <ExportImportFilters />
              <AreaFilter />
              <OtherFilters />
              <MobileClearAllButton onClick={handleClean} />
            </ListViewFilterGroup>
          </ListViewSearchRow>
        </ListViewSearchSection>
        <ClearAllFiltersDesktopButton onClick={handleClean} />
      </ListViewContainer>
    );
  }

  return (
    <div className={styles.filterMainWrapper}>
      <div className={styles.topContainer}>
        <div className={styles.regionsDatasetsWrapper}>
          <RegionDropdown />
          <DatasetsDropdown />
        </div>
        <div className={styles.topContainerButtons}>
          <SavedFiltersButton />
          <AddMoreFiltersButton />
        </div>
      </div>

      <div className={styles.searchWrapper}>
        <SearchFilter />
      </div>

      <FilterGroup onClick={(event) => event.stopPropagation()}>
        <FilterTypes />
        <ExportImportFilters />
        <AreaFilter />
        <OtherFilters />
        <MobileClearAllButton onClick={handleClean} />
      </FilterGroup>

      <ClearAllFiltersDesktopButton onClick={handleClean} />
    </div>
  );
};

export default Filters;
